<header class="header fixed-top pad70">

  <div class="branding b-back">

    <div class="container-fluid">

      <nav class="navbar navbar-expand-lg">

        <!-- ============================= -->
        <!-- MOBILE / TABLET TOGGLE -->
        <!-- ============================= -->
        <button
          class="navbar-toggler"
          type="button"
          (click)="isMobileMenuOpen = !isMobileMenuOpen"
          [attr.aria-expanded]="isMobileMenuOpen"
          aria-controls="commonNavigation"
          aria-label="Toggle navigation">

          <span class="navbar-toggler-icon" >
            <i class="fa fa-bars" aria-hidden="true" style="font-size: 24px; color:#ffffff"></i>
          </span>

        </button>


        <!-- ============================= -->
        <!-- NAVIGATION -->
        <!-- ============================= -->
        <div
          class="navbar-collapse"
          id="commonNavigation"
          [class.mobile-menu-open]="isMobileMenuOpen">

          <div class="header-navigation">


            <!-- ============================= -->
            <!-- LEFT MENU -->
            <!-- ============================= -->
            <ul class="navbar-nav left-menu">

              <!-- VIN Eligibility -->
              <li class="nav-item">

                <a
                  class="nav-link"
                  routerLink="/adlp/eligibility/eligibilityCheck"
                  routerLinkActive="actives"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()">

                  <span>VIN Eligibility</span>

                </a>

              </li>


              <!-- Dashboard -->
              <li
                class="nav-item"
                *ngIf="user === 'role_consumer_fleet'">

                <a
                  class="nav-link"
                  routerLink="/adlp/admin/admindashboard/dashboardfleet"
                  routerLinkActive="actives"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()">

                  Dashboard

                </a>

              </li>

            </ul>


            <!-- ============================= -->
            <!-- RIGHT MENU -->
            <!-- ============================= -->
            <ul class="navbar-nav right-menu">

              <!-- Overview -->
              <li class="nav-item">

                <a
                  class="nav-link"
                  routerLink="/adlp/admin"
                  routerLinkActive="actives"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()">

                  Overview

                </a>

              </li>


              <!-- Onboarding -->
              <li class="nav-item">

                <a
                  class="nav-link"
                  routerLink="/adlp/admin/process"
                  routerLinkActive="actives"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()">

                  Onboarding

                </a>

              </li>


              <!-- Signal Map -->
              <li class="nav-item">

                <a
                  class="nav-link"
                  routerLink="/adlp/admin/cxtaxonomy"
                  routerLinkActive="actives"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobileMenu()">

                  Signal Map

                </a>

              </li>


              <!-- ============================= -->
              <!-- DEVELOPER CORNER -->
              <!-- ============================= -->
              <li
                class="nav-item dropdown"
                ngbDropdown>

                <a
                  class="nav-link developer-link"
                  ngbDropdownToggle>

                  Developer Corner

                  <i class="mdi mdi-chevron-down arrow-h"></i>

                </a>


                <div
                  class="dropdown-menu dropdown-menu-end"
                  ngbDropdownMenu>


                  <!-- Documents -->
                  <a
                    class="dropdown-item"
                    routerLink="/adlp/admin/htmlgenerator"
                    (click)="closeMobileMenu()">

                    <img
                      src="../../../../../assets/images/document-icon.svg"
                      class="img-h">

                    Documents

                  </a>


                  <div class="dropdown-divider"></div>


                  <!-- APIs -->
                  <a
                    class="dropdown-item"
                    routerLink="/adlp/admin/swagger/Fleet"
                    (click)="closeMobileMenu()">

                    <img
                      src="../../../../../assets/images/api-icon.svg"
                      class="img-h">

                    APIs

                  </a>


                  <div class="dropdown-divider"></div>


                  <!-- Trip Simulator -->
                  <a
                    class="dropdown-item"
                    routerLink="/adlp/admin/tools/trip-simulator"
                    (click)="closeMobileMenu()">

                    <img
                      src="../../../../../assets/images/trip-icon.svg"
                      class="img-h-16">

                    Trip Simulator

                  </a>


                  <div class="dropdown-divider"></div>


                  <!-- MCP -->
                  <a
                    class="dropdown-item"
                    routerLink="/adlp/admin/dashoard/mcpSetup"
                    (click)="closeMobileMenu()">

                    <img
                      src="../../../../../assets/images/document-icon.svg"
                      class="img-h-16">

                    MCP

                  </a>

                </div>

              </li>

            </ul>

          </div>

        </div>

      </nav>

    </div>

  </div>

</header>